import { Card, Flex, Loader } from '@mantine/core'
import withErrorBoundaryAndPolicyCheck from '@v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import { type TBreadCrumbItems } from '@v2/commons/components/Breadcrumb'
import EmptyPersons from '@v2/commons/components/EmptyBlock/EmptyPersons.component'
import { POLICIES } from '@v2/commons/config'
import InfiniteScrollTemplate from '@v2/commons/templates/InfiniteScrollTemplate'
import useGetUsersNoPaginattionUseCase from '@v2/domains/user/hooks/useGetUsersNoPagination.useCase'

import TaskTableFilter from '../components/TaskFilters/TaskFilterTable'
import TasksTable from '../components/TaskTable/TasksTable.component'
import useGetTasks from '../hooks/getTasks.hook'
import styles from './tasks-table.module.scss'

const Filters = withErrorBoundaryAndPolicyCheck(
  TaskTableFilter,
  POLICIES.isGetTasksEnabled,
)

const Table = withErrorBoundaryAndPolicyCheck(
  TasksTable,
  POLICIES.isGetTasksEnabled,
)

const breadCrumbItems: TBreadCrumbItems = [
  { title: 'Home' },
  { title: 'Tasks' },
]

const TasksTableView = () => {
  const {
    tasks,
    isLoading,
    isSuccess,
    isFetching,
    getTasksParamsForm,
    totalRecords,
    handlePaginate,
    isProgrammaticFormUpdateRef,
    resetPaginate,
    filtersOpen,
    setFiltersOpen,
  } = useGetTasks()

  const { assignees, usersQueryStatus: useAssigneeQueryStatus } =
    useGetUsersNoPaginattionUseCase()

  return (
    <InfiniteScrollTemplate
      isLoading={isLoading}
      title={'Tasks'}
      breadCrumbItems={breadCrumbItems}
      onScroll={handlePaginate}
      records={{
        totalRecords: totalRecords || 0,
        actualNumberOfRecords: tasks?.length ?? 0,
      }}
    >
      <Card shadow="lg" radius="lg" className={styles['default-card']}>
        <Filters
          getTasksParamsForm={getTasksParamsForm}
          assignees={assignees}
          assigneesQueryStatus={useAssigneeQueryStatus}
          isProgrammaticFormUpdateRef={isProgrammaticFormUpdateRef}
          totalRecords={totalRecords || 0}
          filtersOpen={filtersOpen}
          setFiltersOpen={setFiltersOpen}
        />
        {!!tasks.length && isFetching && (
          <Flex mt="30px" mb="20px" justify="center">
            <Loader size={30} />
          </Flex>
        )}
        {!!tasks.length ? (
          <Table
            tasks={tasks}
            getTasksParamsForm={getTasksParamsForm}
            resetPaginate={resetPaginate}
          />
        ) : (
          isSuccess && !isFetching && <EmptyPersons term="task" />
        )}
        {isFetching && !isLoading && (
          <Flex mt="30px" mb="20px" justify="center">
            <Loader size={30} />
          </Flex>
        )}
      </Card>
    </InfiniteScrollTemplate>
  )
}

export default TasksTableView
